// Version : 0.0.3
// Author : VISHNU
// LastEdit : Sabari
// Last ADD : Unwanted Redux Clear
// MODFIED DATE : 11-11-2025

import { docodeHexResponse } from '../../_common/common.utils';
import ChangeGroupOfficerActionTypes from './change-group-officer.type';

const INITIAL_STATE = {
	// GET BRANCH OFFICER LIST
	getBranchOfficerListResponse: null,
	getBranchOfficerListArr: [],

	// GET CHANGE BRANCH OFFICER LIST
	getChangeBranchOfficerListResponse: null,
	getChangeBranchOfficerListArr: [],

	// GET OFFICER CENTER LIST
	getOfficerCenterListResponse: null,
	getOfficerCenterListArr: [],

	// GET LOAN GROUP LIST
	getLoanGroupListResponse: null,
	getLoanGroupListArr: [],

	// UPDATE CHANGE GROUP OFFICER LIST
	updateChangeGroupOfficerListRespose: null,
};

const changeGroupOfficerReducer = (state = INITIAL_STATE, action: any) => {
	switch (action.type) {
		/************* GET BRANCH OFFICER LIST START *************/
		case ChangeGroupOfficerActionTypes.GET_CHANGE_BRANCH_OFFICER_LIST_SUCCESS:
			return {
				...state,
				getChangeBranchOfficerListResponse: action.payload,
				getChangeBranchOfficerListArr: docodeHexResponse(
					action.payload,
					'GetOfficerListBranchKey',
				),
			};

		case ChangeGroupOfficerActionTypes.GET_CHANGE_BRANCH_OFFICER_LIST_FAILURE:
			return { ...state, getChangeBranchOfficerListResponse: action.payload };

		case ChangeGroupOfficerActionTypes.GET_CHANGE_BRANCH_OFFICER_LIST_RESPONSE_CHANGED:
			return { ...state, getChangeBranchOfficerListResponse: null };
		/************* GET CHANGE BRANCH OFFICER LIST END *************/

		/************* GET OFFICER CENTER LIST START *************/
		case ChangeGroupOfficerActionTypes.GET_OFFICER_CENTER_LIST_SUCCESS:
			return {
				...state,
				getOfficerCenterListResponse: action.payload,
				getOfficerCenterListArr: docodeHexResponse(
					action.payload,
					'GetOfficerCenterListKey',
				),
			};

		case ChangeGroupOfficerActionTypes.GET_OFFICER_CENTER_LIST_FAILURE:
			return { ...state, getOfficerCenterListResponse: action.payload };

		case ChangeGroupOfficerActionTypes.GET_OFFICER_CENTER_LIST_RESPONSE_CHANGED:
			return { ...state, getOfficerCenterListResponse: null };
		/************* GET OFFICER CENTER LIST END *************/

		/************* GET LOAN GROUP LIST START *************/
		case ChangeGroupOfficerActionTypes.GET_LOAN_GROUP_LIST_SUCCESS:
			return {
				...state,
				getLoanGroupListResponse: action.payload,
				getLoanGroupListArr: docodeHexResponse(action.payload, 'GetLoanGroupListKey'),
			};

		case ChangeGroupOfficerActionTypes.GET_LOAN_GROUP_LIST_FAILURE:
			return { ...state, getLoanGroupListResponse: action.payload };

		case ChangeGroupOfficerActionTypes.GET_LOAN_GROUP_LIST_RESPONSE_CHANGED:
			return { ...state, getLoanGroupListResponse: null };
		/************* GET LOAN GROUP LIST END *************/

		/************* UPDATE CHANGE GROUP OFFICER LIST START *************/
		case ChangeGroupOfficerActionTypes.UPDATE_CHANGE_GROUP_OFFICER_LIST_SUCCESS:
			return { ...state, updateChangeGroupOfficerListRespose: action.payload };

		case ChangeGroupOfficerActionTypes.UPDATE_CHANGE_GROUP_OFFICER_LIST_FAILURE:
			return { ...state, updateChangeGroupOfficerListRespose: action.payload };

		case ChangeGroupOfficerActionTypes.UPDATE_CHANGE_GROUP_OFFICER_LIST_RESPONSE_CHANGED:
			return { ...state, updateChangeGroupOfficerListRespose: null };

		default:
			return state;
	}
};

export default changeGroupOfficerReducer;
